/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Container, Text } from 'pixi.js-legacy';
import { LevelOfDetail } from '@appPlanApplication/lod/LevelOfDetail';

export class RenderTime extends Text {
	public container: Container = new Container();
	public preUpdateTime = 0;
	public updateTime = 0;
	public postUpdateTime = 0;
	public renderTime = 0;
	public fps = 0;
	public minFps = 0;
	public maxFps = 0;
	public drawCount = 0;

	private elapsedTime = 0;
	private frameCount = 0;
	private lastTime = 0;

	constructor(text: string, style, stage) {
		super(text, style);
		this.container.x = 100;
		this.container.y = 100;
		this.container.addChild(this);
		stage.addChild(this.container);
		this.update();
	}

	public update() {
		this.text = `Renderer:
			Update:${this.updateTime}ms
			Draw:${this.renderTime}ms
			Detail:${LevelOfDetail.getLOD()}
			FPS:${this.fps}
			FPS min:${this.minFps}
			FPS max:${this.maxFps}`;
		//Total on Screen:${this.drawCount}
	}

	public prepare() {
		this.minFps = 9999;
		this.maxFps = 0;
		this.lastTime = new Date().getTime();
	}

	public onStartFrame() {
		const now = new Date().getTime();

		this.frameCount++;
		this.elapsedTime += now - this.lastTime;

		this.lastTime = now;

		if (this.elapsedTime >= 1000) {
			this.fps = this.frameCount;
			if (this.fps > this.maxFps) {
				this.maxFps = this.fps;
			}
			if (this.fps < this.minFps) {
				this.minFps = this.fps;
			}
			this.frameCount = 0;
			this.elapsedTime -= 1000;
		}
	}

	public onPreUpdate() {
		this.preUpdateTime = new Date().getTime() - this.lastTime;
	}

	public onUpdate() {
		this.updateTime = new Date().getTime() - this.lastTime - this.preUpdateTime;
	}

	public onPostUpdate() {
		this.postUpdateTime = new Date().getTime() - this.lastTime - this.preUpdateTime - this.updateTime;
	}

	public onEndFrame() {
		this.renderTime =
			new Date().getTime() - this.lastTime - this.postUpdateTime - this.preUpdateTime - this.updateTime;

		this.update();
	}
}
